<template>
    <div>
      <div class="row">
        <div class="col-md-12">
          <div class="card">
            <div class="card-header">
                <div class="row">
                  <div class="col-md-3">
                    <h5 class="title">{{ $t( "chargers.reportByCharger") }}</h5>
                  </div>
                  <div class="col-md-3">
                  <div class="text-center spinner-container" v-if="!chargerReport.loaded">
                    <div class="spinner-border" role="status">
                      <span class="sr-only">{{ $t( "general.loading") }}</span>
                    </div>
                  </div>
                  </div>
                  <div class="col-md-6 action-buttons-col form-group">
                    
                    <fg-input>
                        <el-select class="select-default"
                                    @change="refreshData( null /*, $event*/ )"
                                    size="large"
                                    :clearable="false"
                                    v-model="currentPeriod">
                            <el-option v-for="option in periods"
                                    class="select-default"
                                    :value="option.value"
                                    :label="option.name"
                                    :key="option.value">
                                    <span style="float: left"><i class="fa fa-calendar"></i> {{option.name}}</span>
                            </el-option>
                        </el-select>
                    </fg-input>
                    <p-button class="download-xlsx-btn" type="info" @click="downloadXlsx()">
                      <i class="fa fa-cloud-download-alt"></i>
                    </p-button>
                    <p-button class="refresh-btn" type="info" @click="refreshData()">
                       <i class="fa fa-sync-alt"></i>
                    </p-button>
                  </div>
                </div>
            </div>

            <div class="table-responsive table-full-width" v-if="user && user.data && chargerReport.loaded">
              <el-table
                v-if="chargerReport.loaded"
                :default-sort = "{prop: 'value', order: 'ascending'}"
                class="table-expandable"
                :data="chargerReport.data.groupedByCharger"
                ref="tableFleet"
                style="width: 100%">
                { header: "Punjač ID", key: 'chargePointOCPPId', width: 20 },
                <el-table-column
                  sortable
                  :label='$t( "chargers.chargerCode")'
                  prop="chargePointOCPPId">
                </el-table-column>
                <el-table-column
                  sortable
                  :label='$t( "chargers.chargerOwner")'
                  prop="chargerOwnerContactName">
                </el-table-column>
                <el-table-column
                  sortable
                  :label='$t( "chargers.vehicle")'
                  prop="chargerOwnerVehicleModel">
                </el-table-column>
                <el-table-column
                  sortable
                  :label='$t( "chargers.chassis")'
                  prop="chargerOwnerVehicleSasija">
                </el-table-column>
                <el-table-column
                  sortable
                  :label='$t( "chargers.plates")'
                  align="right"
                  prop="chargerOwnerVehicleTablice">
                </el-table-column>
                <el-table-column
                  sortable
                  :label='$t( "chargers.kwh")'
                  prop="chargedEnergy_kWh"
                  :formatter="(r, c, val, i) => formatFloat(val)"
                  align="right"  >
                </el-table-column>
                <el-table-column
                  sortable
                  :label='$t( "chargers.durationCharging")'
                  prop="durationCharging_h"
                  :formatter="(r, c, val, i) => formatFloat(val) + ' h'"
                  align="right">
                </el-table-column>
                <el-table-column
                  sortable
                  :label='$t( "chargers.count")'
                  prop="count"
                  align="right"  >
                  <template slot-scope="scope" v-if="scope.row.count > -1">
                    {{scope.row.count}}
                    <p-button class="action-button" type="success" size="sm" icon title="Pokaži" @click="showTransactionsByCharger(scope.row)">
                        <i class="fa fa-bolt"> </i>
                      </p-button>
                  </template>
                </el-table-column>
              </el-table>
            </div>
          </div>

          <div class="card"  v-if="user && user.data && chargerReport.loaded">
            <div class="card-header">
                <div class="row">
                  <div class="col-md-3">
                    <h5 class="title">{{ $t( "chargers.reportByInitiator") }}</h5>
                  </div>
                </div>
            </div>

            <div class="table-responsive table-full-width">
              <el-table
                v-if="chargerReport.loaded"
                :default-sort = "{prop: 'value', order: 'ascending'}"
                class="table-expandable"
                :data="chargerReport.data.groupedByStarter"
                ref="tableFleet"
                style="width: 100%">
                { header: "Punjač ID", key: 'chargePointOCPPId', width: 20 },
                <el-table-column
                  sortable
                  :label='$t( "chargers.chargedBy")'
                  prop="chargedByContact">
                  <template slot-scope="scope">
                    <span v-if="scope.row.chargedByContactName">{{scope.row.chargedByContactName}}</span>
                    <span v-else>-</span>
                  </template>
                </el-table-column>
                <el-table-column
                  sortable
                  :label='$t( "chargers.kwh")'
                  prop="chargedEnergy_kWh"
                  :formatter="(r, c, val, i) => formatFloat(val)"
                  align="right"  >
                </el-table-column>
                <el-table-column
                  sortable
                  :label='$t( "chargers.durationCharging")'
                  prop="durationCharging_h"
                  :formatter="(r, c, val, i) => formatFloat(val) + ' h'"
                  align="right">
                </el-table-column>
                <el-table-column
                  sortable
                  :label='$t( "chargers.durationStandby")'
                  prop="durationStandby_h"
                  :formatter="(r, c, val, i) => formatFloat(val) + ' h'"
                  align="right">
                </el-table-column>
                <el-table-column
                  sortable
                  :label='$t( "chargers.count")'
                  prop="count"
                  align="right"  >
                  <template slot-scope="scope" v-if="scope.row.count > -1">
                    {{scope.row.count}}
                    <p-button class="action-button" type="success" size="sm" icon title="Pokaži" @click="showTransactionsByInitiator(scope.row)">
                        <i class="fa fa-bolt"> </i>
                      </p-button>
                  </template>
                </el-table-column>
              </el-table>
            </div>
          </div>

        </div>
      </div>
    
      <modal :show.sync="transactionsShown"
        footer-classes="justify-content-center"
        class="transactions-list-modal"
        type="notice"
        v-on:close="closeTransactions" >
        <h5 slot="header" class="modal-title">{{ $t( "chargers.chargingFor") }} {{transactionsFor}}, {{currentPeriod}}</h5>
        <template>
          <div class="table-responsive table-full-width table-transactions-list">
              <el-table
                :default-sort = "{prop: 'value', order: 'ascending'}"
                class="table-expandable"
                :data="chargerTransactions"
                ref="tableFleet"
                height="500"
                style="width1: 100%">
                <el-table-column
                  width="40"
                  :label='getIndexColumnName(this)'
                  :formatter="(r, c, val, i) => ++i + '.'"
                  prop="index">
                </el-table-column>
                <el-table-column
                  sortable
                  :label='$t( "chargers.chargerCode" )'
                  prop="chargePointOCPPId">
                </el-table-column>
                <el-table-column
                  sortable
                  :label='$t( "chargers.vehicle" )'
                  prop="chargedVehicleTablice">
                </el-table-column>
                <el-table-column
                  sortable
                  :label='$t( "chargers.startedAt" )'
                  :formatter="(r, c, val, i) => formatDateTime(val)"
                  prop="startedAt">
                </el-table-column>
                <el-table-column
                  sortable
                  :label='$t( "chargers.stoppedAt" )'
                  :formatter="(r, c, val, i) => formatDateTime(val)"
                  prop="stoppedAt">
                </el-table-column>
                <el-table-column
                  :label='$t( "chargers.kwh" )'
                  prop="chargedEnergy_kWh"
                  :formatter="(r, c, val, i) => formatFloat(val)"
                  width="70"
                  align="right"  >
                </el-table-column>
              </el-table>
            </div>
        </template>
      </modal>

    </div>    
</template>
<script>

  import Vue from 'vue'
  import moment from 'moment'
  import {Table, TableColumn, Input, Select, Option} from 'element-ui'
  import {Button, Card, Modal} from 'src/components/UIComponents'


  Vue.use(Table)
  Vue.use(TableColumn)
  Vue.use(Input)
  Vue.use(Button)

  export default {
    components: {
      [Button.name]: Button,
      [Select.name]: Select,
      [Option.name]: Option,
      Modal,
      Card
    },
    data () {
      return {
        newActivityText: '',
        newActivitySendInProgress: false,
        search: '',
        currentPeriod: moment().format('YYYY-MM'),
        transactionsShown: false,
        chargerTransactions: [],
        chargerOcppId: '',
        periods: [
          { name: moment().format('YYYY-MM'), value: moment().format('YYYY-MM') },
          { name: moment().subtract(1,  'months').format('YYYY-MM'), value: moment().subtract(1,  'months').format('YYYY-MM') },
          { name: moment().subtract(2,  'months').format('YYYY-MM'), value: moment().subtract(2,  'months').format('YYYY-MM') },
          { name: moment().subtract(3,  'months').format('YYYY-MM'), value: moment().subtract(3,  'months').format('YYYY-MM') },
          { name: moment().subtract(4,  'months').format('YYYY-MM'), value: moment().subtract(4,  'months').format('YYYY-MM') },
          { name: moment().subtract(5,  'months').format('YYYY-MM'), value: moment().subtract(5,  'months').format('YYYY-MM') },
          { name: moment().subtract(6,  'months').format('YYYY-MM'), value: moment().subtract(6,  'months').format('YYYY-MM') },
          { name: moment().subtract(7,  'months').format('YYYY-MM'), value: moment().subtract(7,  'months').format('YYYY-MM') },
          { name: moment().subtract(8,  'months').format('YYYY-MM'), value: moment().subtract(8,  'months').format('YYYY-MM') },
          { name: moment().subtract(9,  'months').format('YYYY-MM'), value: moment().subtract(9,  'months').format('YYYY-MM') },
          { name: moment().subtract(10, 'months').format('YYYY-MM'), value: moment().subtract(10, 'months').format('YYYY-MM') },
          { name: moment().subtract(11, 'months').format('YYYY-MM'), value: moment().subtract(11, 'months').format('YYYY-MM') },
          { name: moment().subtract(12, 'months').format('YYYY-MM'), value: moment().subtract(12, 'months').format('YYYY-MM') }
        ]
      }
    },
    mounted() {
      console.log("this.currentPerriod", this.currentPeriod)
      if (!this.$store.chargerReport.store.chargerReport.loaded) this.refreshData();
    },
    computed: {
      chargerReport: function() { return this.$store.chargerReport.store.chargerReport },
      user: function() { return this.$store.user }
    },

    methods: {
      getIndexColumnName() {
        return '#'
      },
      
      showTransactionsByCharger ( row ) {
        let transactions = this.$store.chargerReport.store.chargerReport.data.transactions.filter( t => row.chargePointOCPPId == t.chargePointOCPPId );
        this.transactionsShown = true;
        this.chargerTransactions = transactions;
        this.transactionsFor = row.chargePointOCPPId;
      },
      
      showTransactionsByInitiator (row) {
        let transactions = this.$store.chargerReport.store.chargerReport.data.transactions.filter( t => row.chargedByContactId == t.chargedByContactId );
        this.transactionsShown = true;
        this.chargerTransactions = transactions;
        this.transactionsFor = row.chargedByContactName;
      },

      closeTransactions () {
        console.log('onModalClose');
        this.transactionsShown = false;
      },

      refreshData( err ) {
        this.$store.chargerReport.actions.getChargerReport( this.currentPeriod );
      },

      downloadXlsx ( err, period ) {
        this.$store.chargerReport.actions.getChargerReport( this.currentPeriod, 'xlsx' );
      },

      formatDate(date) {
        if (!date) return '-';
        return moment(date).format('DD.MM.YYYY');
      },
      formatTime(date) {
        if (!date) return '-';
        date = moment(date);
        return `${date.format('HH:mm')}`
      },
      formatWh ( val ) {
        if (!val || val === 'null' || val === '-') return '0';
        val = val / 1000;
        val = val.toFixed(3).replace('.', ',')
        return val;
      },
      formatFloat ( val ) {
        if (!val || val === 'null' || val === '-') return '0';
        val = String(val).replace('.', ',')
        return val;
      },
      formatDateTime(date) {
        if (!date) return '-';
        return `${this.formatDate(date)} ${this.formatTime(date)}`
      }
    }
  }

</script>
<style scoped>
  ::v-deep .card {
    background-color: transparent;
    box-shadow: unset;
  }
  ::v-deep .card-title {
    margin-top: unset;
  }
  ::v-deep .table-expandable tbody .el-table__row {
    background-color: white !important
  }
  ::v-deep .el-table table thead th div{
    text-overflow: clip !important;
    font-size: 0.8em;
    font-weight: bold;
    padding: 0px;
  }
 
  .refresh-btn, .download-xlsx-btn {
    margin-top: 0;
    margin-left: 10px;
    float: right;
  }
  .spinner-container-activity {
    margin-left: 5px;
  }
  .action-button {
    margin-left: 5px !important;
    margin-right: 5px !important;
  }
  .action-button i {
    font-size: 18px !important;
  }
  .action-buttons-col i {
	  font-size: 1.5em;
  }
  .status-icon {
    font-size: 30px !important;
  }
  .status-icon.info {
    color: #51bcda;
  }
  .status-icon.danger {
    color: #ef8157;
  }
  .status-icon.success {
    color: #6bd098;
  }

  .vehicle-request-tickets {
    padding-right: 55px;;
  }
  .speech-bubble {
    position: relative;
    background: #00aabb;
    border-radius: .4em;
    padding: 8px;
    margin-left: auto;

  }
  .msg-container {
    width: fit-content;
    margin-top:10px;
  }

  .from-portal .speech-bubble:after {
    content: '';
    position: absolute;
    top: 50%;
    width: 0;
    height: 0;
    border: 20px solid transparent;
    margin-top: -10px;
    right: 0;
    border-left-color: #B0E7ED;
    border-right: 0;
    border-bottom: 0;
    margin-right: -20px;
    margin-left: auto;
  }
  .from-flota {
    text-align:left;
  }
  .from-flota .speech-bubble {
    background-color: #FDD8A0;
  }

  .from-portal {
    text-align:right;
    margin-left: auto;
  }
  .from-portal .speech-bubble {
    background-color: #B0E7ED;
  }

  .activity-name {
    font-weight: bold;
  }
  .activity-text {
    font-size: 1.2em;
    font-style: italic;
  }
  .activity-text:before {
    content: '"';
  }
  .activity-text:after {
    content: '"';
  }
  .activity-datetime {
    color: gray;
  }
  .activity-input-container {
    margin-top: 20px;
  }
  .activity-input {
    width: 90%;
    background-color: white;
    text-align: center;
  }
  .send-activity-btn {
    height: 38px;
    margin-left: 10px !important;
    padding-top: 2px !important;
  }
  .form-group {
    display: inline-block;
  }
  
  .table-transactions-list col[name="el-table_1_column_1"]  { width: 33px;  }
  .table-transactions-list col[name=".el-table_1_column_2"]  { width: 33px;  }
  
</style>

<style>
  .transactions-list-modal .modal-dialog {
    max-width: 900px !important;
  }
</style>